import SubcategoriesGrid from "@/components/SubcategoriesGrid";
import SubcategoriesPage from "@/components/SubcategoriesPage";

import layouts from "../layouts.module.css";

export const ArticleList = ({ content }) => (
  <SubcategoriesPage
    title={content.main_title}
    blurb={content.description}
    className={layouts.article_list}
  >
    {content.children && content.children.length > 0 && (
      <SubcategoriesGrid>
        {content.children.map((child) => (
          <SubcategoriesGrid.Card
            key={"subcategory-card-" + child._id}
            as="li"
            imgSrc={child.seoImgSrc || child.imgSrc}
            slug={"/" + child.slug.current}
            title={child.title}
          />
        ))}
      </SubcategoriesGrid>
    )}
  </SubcategoriesPage>
);
